import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_use_chemicals_andor_hazardous_substances'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_use_chemicals_andor_hazardous_substances',
  name: 'Does the facility use chemicals and/or hazardous substances?',
  description:
    'Chemicals include elements, compounds and mixtures (both natural and man-made). \r\r\n\r\r\nHazardous substances mean chemicals that affect reproduction or cause birth defects, or if they are cancer-causing, irritants, allergenic, toxic, flammable, explosive, oxidizing, dangerously reactive, or corrosive.\r\r\n\r\r\nExamples of hazardous substances in apparel and footwear: potassium permanganate (for denim finishing), DMF-solvent (for fake leather production), tetrachloroethylene (PERC) (for dry cleaning).',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes- including hazardous substances',
      key: 'YES_INCLUDING_HAZARDOUS_SUBSTANCES',
      slcpIndex: 1,
      slcpOptionName: 'chem-haz',
    },
    {
      name: 'Yes- not including hazardous substances',
      key: 'YES_NOT_INCLUDING_HAZARDOUS_SUBSTANCES',
      slcpIndex: 2,
      slcpOptionName: 'chem-haz',
    },
    {
      name: 'No- no chemicals and no hazardous substances',
      key: 'NO_NO_CHEMICALS_AND_NO_HAZARDOUS_SUBSTANCES',
      slcpIndex: 3,
      slcpOptionName: 'chem-haz',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: [
          'YES_INCLUDING_HAZARDOUS_SUBSTANCES',
          'YES_NOT_INCLUDING_HAZARDOUS_SUBSTANCES',
          'NO_NO_CHEMICALS_AND_NO_HAZARDOUS_SUBSTANCES',
        ],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-26',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 15170,
  sectionId: '2.2.9.5',
  impactArea: 'Chemicals and Hazardous Substances',
  impactAreaId: 'CHEMICALS_AND_HAZARDOUS_SUBSTANCES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
